const PLUGIN = "PAGES";

export const CHANGE_PAGE = `${PLUGIN}_zmena_stranky`;